<template>
  <el-input
      v-model="displayValue"
      :placeholder="placeholder"
      :show-word-limit="showWordLimit"
      :disabled="disabled"
      @mouseenter.native="handleMouseEnter"
      @mouseleave.native="handleMouseLeave"
      @blur="handleBlur"
      @input="handleInput"
      v-bind="$attrs"
      ref="inputRef"
  ></el-input>
</template>

<script>
import {maskMobile} from '@/utils/common';

export default {
  name: 'MaskedInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayValue: '',
      isFocused: false,
      isHovering: false  // 新增悬停状态
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.updateDisplayValue();
      }
    },
    disabled: {
      handler() {
        this.updateDisplayValue();
      }
    }
  },
  methods: {
    // 统一更新显示值的方法
    updateDisplayValue() {
      // 禁用状态下：悬停时显示原始值，否则显示脱敏值
      if (this.disabled) {
        this.displayValue = this.isHovering ? this.value : maskMobile(this.value);
      } else {
        // 非禁用状态：聚焦时显示原始值，否则显示脱敏值
        this.displayValue = this.isFocused ? this.value : maskMobile(this.value);
      }
    },

    handleMouseEnter() {
      this.isHovering = true;
      if (this.disabled) {
        // 禁用状态：只显示原始值，不聚焦
        this.displayValue = this.value;
      } else {
        // 非禁用状态：聚焦并显示原始值
        this.isFocused = true;
        this.displayValue = this.value;
        this.$refs.inputRef.focus();
      }
    },

    handleMouseLeave() {
      this.isHovering = false;
      // 鼠标离开时，根据状态更新显示值
      this.updateDisplayValue();
    },

    handleBlur() {
      if (this.disabled) return;

      this.isFocused = false;
      this.displayValue = maskMobile(this.value);
    },

    handleInput(val) {
      if (this.disabled) return;

      this.$emit('input', val.replace(/\s/g, ''));
    }
  }
};
</script>
